import { createSlice , createSelector} from "@reduxjs/toolkit";

const documentsSlice = createSlice({
  name: "reportsDataSliceName",
  initialState: {
    isLoading: false,
    loaderMessage : "",
    isLoadingNewAdd : false,
    applicationDocuments: {
      documents:[]
      , totalDocument:0
    },
    repositoryDocuments: {
      documents:[]
      , totalDocument:0
    },
  },
  reducers: {
    startApplicationDocumentsData(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setApplicationDocumentsData(state, action) {
      state.applicationDocuments = action.payload;
    },
    startRepositoryDocumentsData(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setRepositoryDocumentsData(state, action) {
      state.repositoryDocuments = action.payload;
    },
    startFolderDocumentsDelete(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    startFileDocumentsDelete(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    startRepositoryFilterData(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setRepositoryFilterData(state, action) {
      state.repositoryDocuments = action.payload;
    },
    startApplicationDocumentsFilterData(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setApplicationDocumentsFilterData(state, action) {
      state.applicationDocuments = action.payload;
    },
    startAddNewFolder(state, action){
     state.isLoadingNewAdd = true;
    },
    startAddNewDocumnet(state, action){
      state.isLoadingNewAdd = true;
    },
    startOfDownloadDocument(state,action){
      state.isLoading = true;
      state.loaderMessage = "Downloading please wait..."
    },
    completedFetch(state, action) {
      state.isLoading = false;
      state.loaderMessage = ""
    },
    completedNewAdd(state, action) {
      state.isLoadingNewAdd = false;
      state.loaderMessage = ""
    },
  },
});

export const {
  startApplicationDocumentsData,
  startAddNewFolder,
  startAddNewDocumnet,
  startOfDownloadDocument,
  startFolderDocumentsDelete,
  startFileDocumentsDelete,
  setApplicationDocumentsData,
  startRepositoryDocumentsData,
  setRepositoryDocumentsData,
  startRepositoryFilterData,
  setRepositoryFilterData,
  startApplicationDocumentsFilterData,
  setApplicationDocumentsFilterData,
  completedFetch,
  completedNewAdd,

} = documentsSlice.actions;

export default documentsSlice.reducer;

///selector
const mainReducer = (state) => state.DocumentsData;
//
export const isLoadingSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.isLoading
);
//
export const applicationsDocumnetsSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.applicationDocuments
);
//
export const repositorysDocumnetsSelector = createSelector(
  [mainReducer],
  (myReducerStore) => myReducerStore.repositoryDocuments
);
//
export const loaderMessageSelector = createSelector(
  [mainReducer],
  (myReducerStore)=> myReducerStore.loaderMessage
);

export const addRefreshMessageSelector = createSelector(
  [mainReducer],
  (myReducerStore)=> myReducerStore.isLoadingNewAdd
);
//